import { Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { useAppDispatch } from "./store/hooks";
import { fetchMe } from "./store/slices/authSlice";
import Login from "./pages/Login/Login";
import AppLayout from "./components/AppLayout/AppLayout";
import ActivateUser from "./pages/ActivateUser/ActivateUser";
import "./App.css";

function App() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchMe());
  }, [dispatch]);

  return (
    <Routes>
      <Route path="/activate" element={<ActivateUser />} />
      <Route path="/login" element={<Login />} />
      <Route path="/*" element={<AppLayout />} />
    </Routes>
  );
}

export default App;
